/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembershipPurchaseSessionCreatedResponse } from '../../models/membership-purchase-session-created-response';
import { MembershipsOrderRequest } from '../../models/memberships-order-request';

export interface CreateMembershipsPurchaseSession$Params {
      body: MembershipsOrderRequest
}

export function createMembershipsPurchaseSession(http: HttpClient, rootUrl: string, params: CreateMembershipsPurchaseSession$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipPurchaseSessionCreatedResponse>> {
  const rb = new RequestBuilder(rootUrl, createMembershipsPurchaseSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipPurchaseSessionCreatedResponse>;
    })
  );
}

createMembershipsPurchaseSession.PATH = '/api/memberships/create-purchase-session';
